import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface JobParametersProps {
    jobData: any;
}

const JobParameters: React.FC<JobParametersProps> = ({ jobData }) => {
    const jobParams = jobData?.parsed_json_data?.['JOB PARAMETERS']?.values || {};

    const getUnitLabel = (units: any) => {
        if (!units) return '';
        if (typeof units === 'string') return units;
        if (typeof units === 'object') {
            // Try to get imperial unit first, then metric, then unit, then roundOff
            return units.imperial || units.metric || units.unit || '';
        }
        return '';
    };

    const renderSection = (sectionName: string, sectionData: any) => {
        if (!sectionData || Object.keys(sectionData).length === 0) return null;

        return (
            <Card key={sectionName} className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">{sectionName}</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
                        {Object.entries(sectionData).map(([key, valueData]: [string, any]) => {
                            const unitLabel = getUnitLabel(valueData?.units);
                            return (
                                <div key={key} className="min-w-0">
                                    <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">{valueData?.text || key}</div>
                                    <div className="text-[13px] font-medium text-text-grey">
                                        {valueData?.value !== undefined && valueData?.value !== null ? String(valueData.value) : '-'}
                                        {unitLabel && ` ${unitLabel}`}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardContent>
            </Card>
        );
    };

    const sections = ['Identification', 'Machine Setup', 'Welding Wire', 'Gas Parameters', 'Travel Parameters', 'Torch Parameters', 'Sensor Parameters', 'Motor Jog Setup', 'Logging Setup'];

    return (
        <div className="p-6 space-y-4">
            {sections.map(section => renderSection(section, jobParams[section]))}
        </div>
    );
};

export default JobParameters;

